import Axios from "axios";
import {
  SET_HRM_EMPLOYEE_KPI_REPORT_LIST,
  UNSET_HRM_EMPLOYEE_KPI_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getHrmEmployeeKpiReport,
} from "@/store/api";

const state = {
  getHrmEmployeeKpiReport: [],
};

const getters = {
  getHrmEmployeeKpiReport(state) {
    return state.getHrmEmployeeKpiReport;
  },
};

const mutations = {
  [SET_HRM_EMPLOYEE_KPI_REPORT_LIST](state, data) {
    state.getHrmEmployeeKpiReport = data;
  },
  [UNSET_HRM_EMPLOYEE_KPI_REPORT_LIST](state) {
    state.getHrmEmployeeKpiReport = [];
  },
};

const actions = {
  getHrmEmployeeKpiReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(`${getHrmEmployeeKpiReport}`, data)
        .then((response) => {
          commit(SET_HRM_EMPLOYEE_KPI_REPORT_LIST, response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          commit(UNSET_HRM_EMPLOYEE_KPI_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,  
  getters,
  actions,
  mutations,
};

